import axios from "axios";

export type User = {
  id: number;
  email: string;
  password: string;
  googleId: string | null;
  firstName: string;
  lastName: string | null;
  avatar: string | null;
  phone: string | null;
  phoneCountryCode: string | null;
  role: "Admin" | "User" | "Moderator";
  jobTitle: string | null;
  interests: string | null;
  yearsOfExperience: number;
  gender: "Male" | "Female" | "Other" | null;
  dateOfBirth: string | null;
  address: string | null;
  isActive: boolean;
  isVerifiedPhone: boolean;
  isVerifiedEmail: boolean;
  createdAt: string;
  device: string | null;
  mode: "Light" | "Dark";
  ipAddress: string | null;
  updatedAt: string;
  deletedAt: string | null;
};

export enum Interests {
  AMBITION = "Ambition",
  COMPASSION = "Compassion",
  CREATIVITY = "Creativity",
  ENVIRONMENTALISM = "Environmentalism",
  FITNESS_AND_HEALTH = "Fitness_And_Health",
  ADVENTURE = "Adventure",
  HUMOR = "Humor",
  RELIABILITY = "Reliability",
  SOCIAL_JUSTICE = "Social_Justice",
  SPIRITUALITY = "Spirituality",
}

export const getMe = (): Promise<{ data: User }> => {
  return axios.get("/users/me");
};
